import type { IntlShape } from 'react-intl';
import type { ToolUseItem } from '../../../../contracts/harness.types';

import type { ArtefactPayload } from './shared/artefact-tool';
import {
  buildPptxOnPreview,
  renderStandardExportToolUse,
  type OpenExportDocumentPayload,
} from './shared/exportDocumentPreview';
import { readStandardExportPayload, readString, readToolData } from './shared/readers';

import type { JSX } from 'react';

const readGeneratePptxPayload = (item: ToolUseItem): ArtefactPayload => ({
  ...readStandardExportPayload(item),
  presentationId: readString(readToolData(item), 'presentation_id'),
});

export const renderGeneratePptxToolUse = (
  item: ToolUseItem,
  intl: IntlShape,
  onOpenPresentation?: (presentationId: string) => void,
  onOpenDocumentExport?: (payload: OpenExportDocumentPayload) => void
): JSX.Element | null =>
  renderStandardExportToolUse(item, intl, {
    artefactType: 'pptx',
    titleFallback: { id: 'pjArtPpt03', defaultMessage: 'PowerPoint export' },
    readPayload: readGeneratePptxPayload,
    buildOnPreview: buildPptxOnPreview(onOpenPresentation, onOpenDocumentExport),
  });
